import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState, useEffect } from "react";

export default function NewDateStandardInput({
  value,
  onChange,
  label,
  ...props
}) {
  const [internalValue, setInternalValue] = useState(value || null);
  const [isFocused, setIsFocused] = useState(false);

  // Sync internal value with the value passed from the parent
  useEffect(() => {
    setInternalValue(value || null);
  }, [value]);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const handleChange = (newValue) => {
    setInternalValue(newValue);
    onChange(newValue); // Notify parent of the change
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={!isFocused && !internalValue ? label : ""}
        format="DD/MM/YYYY"
        disableFuture
        minDate={props.minDate}
        maxDate={props.maxDate}
        sx={{
          fontFamily: "Montserrat",
          height: '50px',
          color: '#231A3D',
          width: '100%',
          fontSize: "14px",
          justifyContent: 'flex-end',
          "& .MuiInputLabel-root": {
            fontSize: "14px",
            fontFamily: props.labelFontFamily ? props.labelFontFamily : "Montserrat",
            fontWeight: props.labelFontWeight ? props.labelFontWeight : "",
            color: props.labelColor ? props.labelColor : "", 
          },
          "& .MuiInputBase-root": {
            fontSize: "14px",
            padding: "4px 0 4px",
            opacity: '0.8'
          },
          "& .MuiButtonBase-root.MuiIconButton-root": {
            padding: "2px 16px 4px",
            "&:hover": {
              transform: "scale(1.1)",
              backgroundColor: "transparent",
            },
          },
          ".MuiSvgIcon-root": {
            width: "1.8rem",
            height: "1.8rem",
            color: "rgba(0, 0, 0, 1)",
          },
        }}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
          textField: {
            variant: "standard",
            InputLabelProps: {
              shrink: false,
            },
            onFocus: handleFocus,
            onBlur: handleBlur,
          },
          layout: {
            sx: {
              fontSize: "16px !important",
              fontFamily: "Montserrat",
              "& *": {
                fontSize: "16px !important",
                fontFamily: "Montserrat",
              },
            },
          },
        }}
        value={internalValue}
        onChange={handleChange} // Handle change and notify parent
      />
    </LocalizationProvider>
  );
}
